import request from '../utils/http'

const fddapis = {
     //查询列表
     getTemplateList : query => {
        return request({
            url: '/fdd/getTemplateList',
            method: 'get',
            params:query
        });
    },
     //查询列表
     getTemplateParamList : query => {
        return request({
            url: '/fdd/getTemplateParamList',
            method: 'get',
            params:query
        });
    },
     //新增
     addTemplate : query => {
        return request({
            url: '/fdd/addTemplate',
            method: 'post',
            data: query
        });
    },
     //修改
     updateTemplate : query => {
        return request({
            url: '/fdd/updateTemplate',
            method: 'post',
            data: query
        });
    },
      //删除
      deleteTemplate : query => {
        return request({
            url: '/fdd/deleteTemplate',
            method: 'post',
            params: query
        });
    },
          getTemplateView : query => {
        return request({
            url: '/fdd/getTemplateView',
            method: 'post',
            params: query
        });
    },
      getFddSignView : query => {
        return request({
            url: '/fdd/getFddSignView',
            method: 'post',
            params: query
        });
    },
      //上传模板
      uploadFileToFdd : query => {
        return request({
            url: '/files/uploadFileToFdd',
            method: 'post',
            data: query
        });
    },
    getFlowList : query => {
        return request({
            url: '/fdd/getFlowList',
            method: 'get',
            params:query
        });
    },
    createContract : query => {
        return request({
            url: '/fdd/createContract',
            method: 'post',
            data: query
        });
    },
        //查询银行列表
        getYjConfig : query => {
            return request({
                url: '/yjBank/getYjConfig',
                method: 'get',
                params:query
            });
        },
             //修改银行
     updateYjConfig : query => {
        return request({
            url: '/yjBank/updateYjConfig',
            method: 'post',
            data: query
        });
    },
    changeYjUserPhone : query => {
        return request({
            url: '/fdd/changeYjUserPhone',
             method: 'post',
            data: query
        });
    },
     toUpdateContractState : query => {
        return request({
            url: '/fdd/toUpdateContractState',
            method: 'post',
            params: query
        });
    },
        sendMessage : query => {
        return request({
            url: '/admin/sendMessage',
             method: 'post',
            data: query
        });
    },
}


export default fddapis
